import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Layout from "../components/Layout";
import Error from "../pages/Error";
import openPaths from "./openPaths";

const Routers = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <Error />,
      children: openPaths,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Routers;
